import {
  GET_GROUPS_AND_TEES_LOADING,
  GET_GROUPS_AND_TEES_ERROR,
  GET_GROUPS_AND_TEES_SUCCESS
} from "../../../constant/actionTypes";

const groupsAndTeesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_GROUPS_AND_TEES_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_GROUPS_AND_TEES_SUCCESS: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case GET_GROUPS_AND_TEES_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default groupsAndTeesReducer;
